/*
 * @Author: Lemon C
 * @Date: 2024-06-14 09:57:59
 * @LastEditTime: 2025-03-12 11:35:50
 */
import { defineStore } from 'pinia';
import globalObj from '../utils/globalObj';

// 全局状态管理
export const useStateStore = defineStore('state', {
    state: () => ({
        nav_type: 0, // 0:首页 1:产品功能 2:开发者文档 3:下载与更新 4:黑洞生态（暂不做） 5:联系我们（移除） 6:常见问题
        nav_bg_style: 0, // 0:Light 1:Dark
        need_scroll_top_btn: false, // false: 不需要 true: 需要
        need_footer: false, // false: 不需要 true: 需要
        need_docsBreadcrumb_shadow: false, // false: 不需要 true: 需要
        scroll_anchor_click: false, //主动触发锚点滚动
        docs_content_type_curr: globalObj.docs_content_type.md,
        nav_user_box_pos: { top: 0, left: 0 }, //用户头像位置信息
    }),
    actions: {
        // 更新状态
        updateState() {
            this.checkLoginBgStyle();
            this.checkScrollTopBtnState();
            this.checkNeedFooter();
            this.resetState();
        },
        // 检查导航栏背景色
        checkLoginBgStyle() {
            this.nav_bg_style = 0;
            let path = this.route.path;
            if (this.nav_type === 2 || this.nav_type === 3 || this.nav_type === 6) {
                if (!path.includes('docs-center')) {
                    this.nav_bg_style = 1;
                }
            } else if (this.nav_type === 0) {
                if (path.includes('msg-center')) {
                    this.nav_bg_style = 1;
                }
            }
        },
        // 检查滚动到顶部按钮显示状态
        checkScrollTopBtnState() {
            this.need_scroll_top_btn = false;
            let path = this.route.path;
            if (path.includes('home') || path.includes('product-ability') || path.includes('docs-center') || path.includes('contact')) {
                this.need_scroll_top_btn = true;
            }
        },
        // 检查是否需要底部footer
        checkNeedFooter() {
            this.need_footer = false;
            let path = this.route.path;
            if (path.includes('home') || path.includes('product-ability') || path.includes('docs-center') || path.includes('contact')) {
                this.need_footer = true;
            }
        },
        // 重置状态
        resetState() {
            this.need_docsBreadcrumb_shadow = false;
        },
    },
});
